module.exports = __webpack_public_path__ + "public/img/13.303cc346.png";